const CHUNK_LOAD_ERROR_PATTERN = /Loading chunk [\d]+ failed|Loading CSS chunk [\d]+ failed|ChunkLoadError|Failed to fetch dynamically imported module/i

function unwrapChunkLoadError(error: unknown): unknown {
  if (!error || typeof error !== 'object') return error
  const errorObject = error as Record<string, unknown>
  if (errorObject['rejection']) return unwrapChunkLoadError(errorObject['rejection'])
  if (errorObject['originalError']) return unwrapChunkLoadError(errorObject['originalError'])
  if (errorObject['error']) return unwrapChunkLoadError(errorObject['error'])
  return error
}

function getChunkLoadErrorMessage(error: unknown): string {
  if (typeof error === 'string') return error
  if (error instanceof Error) return error.message
  if (error && typeof error === 'object' && typeof (error as Record<string, unknown>)['message'] === 'string') return (error as Record<string, string>)['message']
  return ''
}

function getChunkLoadErrorName(error: unknown): string {
  if (error instanceof Error) return error.name
  if (error && typeof error === 'object' && typeof (error as Record<string, unknown>)['name'] === 'string') return (error as Record<string, string>)['name']
  return ''
}

export function isChunkLoadError(error: unknown): boolean {
  const unwrappedError = unwrapChunkLoadError(error)
  if (getChunkLoadErrorName(unwrappedError) === 'ChunkLoadError') return true
  return CHUNK_LOAD_ERROR_PATTERN.test(getChunkLoadErrorMessage(unwrappedError))
}
